import {apiFetch} from '../../Config/api'

export function contact(data) {
    return apiFetch('contact', data)
}
